<ui-modal
  class="load-report-modal"
  [isOpened]="showModal"
  modalTitle="Load A Report"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="load-report-modal__container">
    <div
      class="load-report-modal__container__error"
      *ngIf="loadReportDateTimesErrMessage; else selectTrade"
    >
      {{ loadReportDateTimesErrMessage }}
    </div>
    <ng-template #selectTrade>
      <ng-container *ngIf="fetchingReports !== 'DONE'; else showReport">
        <div class="load-report-modal__container__select-trade">
          {{
            loadReportDateTimes
              ? 'Select a report to view'
              : 'Retrieving reports to view'
          }}
          <div class="load-report-modal__container__select-trade__selector">
            <select
              clrSelect
              (change)="selectReport($any($event.target).value)"
            >
              <option disabled selected value hidden></option>

              <option
                *ngFor="let timestamp of loadReportDateTimes"
                [value]="timestamp"
              >
                {{ timestamp | date: 'dd MMM yyyy h:mm:ss a' }}
              </option>
            </select>
          </div>
        </div>
      </ng-container>
      <ng-template #showReport>
        <div
          class="load-report-modal__container__select-trade__ag-grid__container"
          *ngIf="headers && rowData"
        >
          <ag-grid-angular
            class="
              ag-theme-balham-dark
              load-report-modal__container__select-trade__ag-grid__container__grid
            "
            [columnDefs]="$any(headers)"
            rowSelection="multiple"
            [rowData]="rowData"
            [sideBar]="sideBarDef"
            [groupSelectsChildren]="true"
            [suppressRowClickSelection]="true"
          >
          </ag-grid-angular>
        </div>
      </ng-template>
    </ng-template>
  </div>
</ui-modal>
